import { useState, useEffect } from 'react';
import supabase from '../supabase/supabase';

export const useLabel = (slug) => {
  const [label, setLabel] = useState(null);
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;
    fetchLabel();
  }, [slug]);

  const fetchLabel = async () => {
    try {
      setLoading(true);
      setError(null);
      const { data, error: err } = await supabase
        .from('d2f_labels')
        .select('*')
        .eq('slug', slug)
        .maybeSingle();
      if (err) throw err;
      if (!data) throw new Error('Label not found');
      setLabel(data);

      const { data: artistsData } = await supabase
        .from('d2f_artists')
        .select('id, name, slug, genre, cover_image, supporter_count, verified')
        .eq('label_id', data.id);
      setArtists(artistsData || []);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return { label, artists, loading, error };
};